export interface SegmentAudioSlotDef {
  order: number;
  label: string;
  shortLabel: string;
  description: string;
  role: 'prompt' | 'answer';
}

export const STRUCTURAL_SEGMENT_AUDIO_SLOTS: SegmentAudioSlotDef[] = [
  {
    order: 0,
    label: 'Prompt voice',
    shortLabel: 'Prompt',
    description: 'Plays when the student clicks Start (before answers).',
    role: 'prompt',
  },
  {
    order: 1,
    label: 'Answer voice 1',
    shortLabel: 'Answer 1',
    description: 'First model answer — shown after Next.',
    role: 'answer',
  },
  {
    order: 2,
    label: 'Answer voice 2',
    shortLabel: 'Answer 2',
    description: 'Second model answer — shown after Next.',
    role: 'answer',
  },
];

export const STRUCTURAL_SEGMENT_MIN_AUDIOS = STRUCTURAL_SEGMENT_AUDIO_SLOTS.length;
